// TODO move all venues actions from consts

export const FETCH_VENUE_GAME_STATS = 'FETCH_VENUE_GAME_STATS';
export const RESET_VENUE_GAME_STATS = 'RESET_VENUE_GAME_STATS';

export const CANCEL_LISTING = 'CANCEL_LISTING';
export const RESET_LISTINGS = 'RESET_LISTINGS';
